export default __webpack_public_path__ + "static/media/img21.f8d272a1.jpeg";